import React, { useEffect, useCallback, useState } from "react";
import { Layout } from "antd";
import { useNavigate } from "react-router-dom";

import TopHeader from "../../common/TopHeader/TopHeader";
import Sidebar from "../../common/Sidebar/Sidebar";
import UserApi from "../../common/Apis/UserApi";
// import FooterDashboard from "../../common/FooterDashboard/FooterDashboard";
const UserHealth = () => {
  let navigate = useNavigate();
  const { Content } = Layout;
  const urlParams = new URLSearchParams(window.location.search);
  const userEmail = urlParams.get("email");
  const username = urlParams.get("name");
  const [UserHealthAnswer, setUserHealthAnswer] = React.useState();
  const getUserHealthAnswer = useCallback(() => {
    UserApi.UserHealthAnswer(userEmail)
      .then((response) => {
        console.log(response);
        setUserHealthAnswer(response?.payloadDto);
      })
      .catch((err) => {});
  }, []);

  const [isLoading, setIsLoading] = useState(false);
  const PageLoading = useCallback(() => {
    setIsLoading(true);
    setTimeout(() => {
      setIsLoading(false);
    }, 800);
  }, []);

  useEffect(() => {
    getUserHealthAnswer();
    PageLoading();
  }, [getUserHealthAnswer, PageLoading]);

  return (
    <Layout style={{ minHeight: "100vh" }}>
      <Sidebar />
      <Layout>
        <TopHeader />
        {isLoading && (
          <div className="spinner-overlay" id="spinnerOverlay">
            <div className="spinner"></div>
          </div>
        )}
        <Content
          className="form-content nav-content"
          style={{
            margin: "14px 16px 0",
            padding: "30px",
            background: "white",
          }}
        >
          <div>
            <div className="col-xl-12 col-lg-7 col-md-12 px-0 healthCondent">
              {UserHealthAnswer && (
                <>
                  <h5>
                    <b>Name</b> : {username} <br />
                    <b>Email</b> : {UserHealthAnswer[0]?.email}
                  </h5>{" "}
                  <br />
                  <h4 className="py-3 text-center">
                    <b>Health Question And Answer</b>
                  </h4>
                  {UserHealthAnswer
                    .filter(item => item.questionnaireId === 2)
                    .map(item =>
                      item.questionAndAnswerDTOList.map((qaItem, index) => (
                        <h5 key={index} className="pt-2">
                          <b>Question {index + 1}</b> : {qaItem?.question} <br />
                          <b>Answer</b> : {qaItem?.answer == "true" ? "Yes" : "No"}
                        </h5>
                      ))
                    )}
                </>
              )}
            </div>
          </div>
        </Content>
        {/* <FooterDashboard /> */}
      </Layout>
    </Layout>
  );
};

export default UserHealth;
